export const READY = "MAIN_ROUTER:READY";
export const CHANGE_LOCATION = "MAIN_ROUTER:CHANGE_LOCATION";
export const HISTORY_LOCATION_CHANGE = "MAIN_ROUTER:HISTORY:LOCATION:CHANGE";